// @ts-ignore
import { UrlUtility } from '@ikea-aoa/ikea-shared-utils';
import SeriesGallery from '../SeriesGallery';
import useCountdown from '../../hooks/useCountdown';
import { useSelector } from 'react-redux';
import { selectDialog } from '../../state/dialog/dialogSelectors';
import { State } from '../../state/StateTypes';
import { selectIsView } from '../../state/navigation/navigationSelectors';
import masterConstants from '../../settings/masterConstants';

const useScreensaverTimer = () => {
  const dialogIsSeriesGallery =
    useSelector(selectDialog).type === SeriesGallery;
  const isStartView = useSelector((state: State) =>
    selectIsView(masterConstants.VIEW_NAMES.START)(state)
  );

  /**
   * Convert sessionStorage time from milliseconds to seconds, and decides
   * based on ipex gallery being active, whether ipex timers or our timers
   * should be used.
   */
  const cleanedDelays = () => {
    const { nonGalleryDelay, inGalleryDelay, countdown } = JSON.parse(
      // @ts-ignore
      sessionStorage.getItem('screenSaverTimers')
    );

    const { idleTime, ipexGallery } = UrlUtility.getCombinedQuery();

    return {
      nonGalleryDelay: idleTime
        ? parseInt(idleTime, 10)
        : nonGalleryDelay / 1000,
      inGalleryDelay: idleTime ? parseInt(idleTime, 10) : inGalleryDelay / 1000,
      countdown: ipexGallery === 'true' ? 90 : countdown / 1000,
    };
  };

  const { nonGalleryDelay, inGalleryDelay, countdown } = cleanedDelays();

  /**
   * decides what aware timer should be based on dialog type and current view
   */
  const getAwareTimer = () =>
    dialogIsSeriesGallery || isStartView ? inGalleryDelay : nonGalleryDelay;

  /**
   * Calculates start time
   */
  const getStartTime = () =>
    getAwareTimer() + (dialogIsSeriesGallery ? 1 : countdown);

  return {
    ...useCountdown({ time: getStartTime() }),
    countdown,
  };
};

export default useScreensaverTimer;
